module.exports = "<div id=\"{{uniqueMapId}}\" class=\"cx-world-map\"></div>\n"